// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import API_BASE_URL from "../apiConfig";
// import { useNavigate } from "react-router-dom";

// const EstructuraNiveles = () => {
//   const [estructura, setEstructura] = useState([]);
//     const navigate = useNavigate();

//   // Obtener datos de la estructura por niveles
//   useEffect(() => {
//     const fetchEstructura = async () => {
//       try {
//         const response = await axios.get(`${API_BASE_URL}/Lider/EstructuraPorNiveles`);
//         setEstructura(response.data);
//       } catch (error) {
//         console.error(" Error al obtener estructura:", error);
//       }
//     };

//     fetchEstructura();
//   }, []);

//   return (
//     <div className="wrapper p-6 flex flex-col items-center space-y-6">
//       {/* LOGO  */}
//       <img src="/img/monytorlogoa.png" alt="Logo" className="login-image" />

//       {/*  Título */}
//       <h2 className="text-white text-3xl font-bold">Estructura por Niveles</h2>

//       {/*  Botón Volver */}
//       <button className="btn" onClick={() => navigate("/admin/menu")}>
//           Regresar al Menú
//         </button>

//       {/*  Tabla de estructura por niveles */}
//       <div className="w-full max-w-4xl overflow-x-auto">
//         <table className="w-full bg-[#081b29] border border-gray-700 text-white rounded-lg">
//           <thead>
//             <tr className="bg-[#0f283a] text-white">
//               <th className="px-6 py-3 border border-gray-700">Nivel</th>
//               <th className="px-6 py-3 border border-gray-700">Descripción</th>
//               <th className="px-6 py-3 border border-gray-700">Total Líderes</th>
//               <th className="px-6 py-3 border border-gray-700">Total Participantes</th>
//             </tr>
//           </thead>
//           <tbody>
//             {estructura.length > 0 ? (
//               estructura.map((nivel, index) => (
//                 <tr key={index} className="text-center border border-gray-700 hover:bg-[#12394d] transition">
//                   <td className="px-6 py-3 border border-gray-700">{nivel.nivelId}</td>
//                   <td className="px-6 py-3 border border-gray-700">{nivel.nivelDescripcion}</td>
//                   <td className="px-6 py-3 border border-gray-700">{nivel.totalLideres}</td>
//                   <td className="px-6 py-3 border border-gray-700">{nivel.totalParticipantes}</td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="3" className="text-center py-4 text-gray-400">
//                   No hay datos disponibles.
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// };

// export default EstructuraNiveles;


import React, { useState, useEffect } from "react";
import axios from "axios";
import API_BASE_URL from "../apiConfig";
import { useNavigate } from "react-router-dom";
import SidebarMenu from '../components/SidebarMenu';

const EstructuraNiveles = () => {
  const [estructura, setEstructura] = useState([]);
  const [lideres, setTotalLideres] = useState(0);
  const [participantes, setTotalParticipantes] = useState(0);
  const navigate = useNavigate();

  //  Obtener datos de la estructura por niveles
  useEffect(() => {
    const fetchEstructura = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/Lider/EstructuraPorNiveles`);
        console.log("📢 Datos recibidos de la API:", response.data); // Verifica la respuesta

        // Extraemos los valores correctamente
        setEstructura(response.data.estructura || []);
        setTotalLideres(response.data.lideres);  //  Cambio aquí
    setTotalParticipantes(response.data.participantes);  //  Cambio aquí
      } catch (error) {
        console.error("❌ Error al obtener estructura:", error);
      }
    };

    fetchEstructura();
  }, []);

  return (
    <div className="wrapper p-6 flex flex-col items-center space-y-6">
       <SidebarMenu />
     <div className="bg-[#081b29] p-4 flex items-center justify-between">
      {/* Logo y Título juntos en el lado izquierdo */}
      <div className="flex items-center space-x-4">
        <img src="/img/monytorlogoa.png" alt="Logo" className="w=32 h-32" />
        <h2 className="text-white text-3xl font-bold">Auditoría de Eventos</h2>
      </div>

      {/* Botón en el lado derecho */}
      <div className="flex-grow"></div>
      <button
      className="btn text-white font-bold py-1 px-2 rounded ml-100"
      style={{ width: '100px' }}  // Ancho fijo
      onClick={() => navigate("/administradorMenu")}
    >
        Menú
      </button>
    </div>

      {/*  Resumen General */}
      <div className="w-full max-w-lg bg-[#081b29] text-white p-4 rounded-lg shadow-md border border-gray-700">
        <h3 className="text-lg font-semibold text-center">Resumen General</h3>
        <div className="flex justify-around mt-2">
          <span className="text-green-400"> Total Líderes: {lideres}</span>
          <span className="text-blue-400"> Total Participantes: {participantes}</span>
        </div>
      </div>


      {/*  Tabla de estructura por niveles */}
      <div className="w-full max-w-4xl overflow-x-auto">
        <table className="w-full bg-[#081b29] border border-gray-700 text-white rounded-lg">
          <thead>
            <tr className="bg-[#0f283a] text-white">
              <th className="px-6 py-3 border border-gray-700">Nivel</th>
              <th className="px-6 py-3 border border-gray-700">Descripción</th>
              <th className="px-6 py-3 border border-gray-700">Total Líderes</th>
              <th className="px-6 py-3 border border-gray-700">Total Participantes</th>
            </tr>
          </thead>
          <tbody>
            {estructura.length > 0 ? (
              estructura.map((nivel) => (
                <tr key={nivel.nivelId} className="text-center border border-gray-700 hover:bg-[#12394d] transition">
                  <td className="px-6 py-3 border border-gray-700">{nivel.nivelId}</td>
                  <td className="px-6 py-3 border border-gray-700">{nivel.nivelDescripcion}</td>
                  <td className="px-6 py-3 border border-gray-700">{nivel.totalLideres}</td>
                  <td className="px-6 py-3 border border-gray-700">{nivel.totalParticipantes}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className="text-center py-4 text-gray-400">
                  No hay datos disponibles.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default EstructuraNiveles;
